<template>
  <div class="item mb-10 flex">
    <div class="pic" v-if="goodItem.goodsPicList">
      <el-image :src="Utils.IMG_PREV + goodItem.goodsPicList[0].pic" fit="cover" class="w-100 h-100"></el-image>
    </div>
    <div class="right flex-column">
      <div class="color-ff font-16 font-yahei mb-10">{{goodItem.name}}</div>
      <div class="font-12 color-94 flex-1">
        <div class="flex align-center mb-4" v-for="(item,index) in goodItem.caseSpaceAttributeList" :key="index">{{item.standard}}<div class="w-130 text-overflow ml-10">{{item.value}}</div></div>
        <div class="flex align-center">编码<div class="w-130 text-overflow ml-10">{{goodItem.number}}</div></div>
      </div>
      <div class="flex align-end justify-space-between">
        <div class="flex-1 w-0">
          <div class="font-18 color-c19357 font-arial mr-10">¥{{Utils.toFixedNum(goodItem.isPeferential == 1 ? goodItem.summaryPreferentialPrice : goodItem.summaryPrice)}}</div>
          <!-- <div class="linethrough color-ca font-12 font-arial">¥{{Utils.toFixedNum(goodItem.price)}}</div> -->
        </div>
        <el-input-number v-model="goodItem.quantity" :min="1"></el-input-number>
      </div>
    </div>
    <div class="operate">
      <img :src="isSelect ? '/images/xuan-xz.png' : '/images/xuan.png'" alt="" class="cursor" @click="chooseGoods" v-if="goodItem.isEmpty == 0">
      <img src="/images/wuhuoshangpin.png" alt="" class="mr-5" v-if="goodItem.isEmpty == 1">
    </div>
  </div>
</template>

<script>

export default {
  name: "GoodsCase",
  components: {},
  props: ['spaceIndex', 'goodIndex', 'goodItem'],
  data () {
    return {
      num: 0,
      isSelect: false,
      imgList: [{
        url:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602583861525&di=45c2f77b0d0520ff2c9b7620967d9c0b&imgtype=0&src=http%3A%2F%2Ftgi12.jia.com%2F121%2F266%2F21266396.jpg'
      }, {
        url:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602583959068&di=a784de98b4184106ef1e698002f4297b&imgtype=0&src=http%3A%2F%2F04.imgmini.eastday.com%2Fmobile%2F20180613%2F20180613133542_9138a5b1fab6038d0990453dc7e206b7_12.jpeg'
      }, {
        url:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602583976620&di=51b7f454571a0b56179bb71a56e4c201&imgtype=0&src=http%3A%2F%2Fimg.fuwo.com%2Fattachment%2F1610%2F22%2Fd946f62a980211e691a800163e00254c.jpg'
      }],
      imgIndex: 0,
      isSwitch: false
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    chooseGoods () {
      this.isSelect = !this.isSelect
      let params = {
        isSelect: this.isSelect,
        spaceIndex: this.spaceIndex,
        goodIndex: this.goodIndex
      }
      this.$emit('on-choose',params)
    },
    onImg (e) {
      this.imgIndex = e
    },
    onDelete () {
      this.$emit('delete', this.index)
    }
  },
  watch: {
    imgIndex (e) {
      this.isSwitch = true
      setTimeout(() => {
        this.isSwitch = false
      }, 300)
    }
  }
};
</script>

<style lang="scss" scoped>
  .item{
    width: 100%;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    .pic{
      // height: 190px;
      width: 286px;
    }
    .right{
      background: #292a2e;
      padding: 26px 28px 28px;
      flex: 1;
    }
  }
  .w-130{
    width: 130px;
  }
  .operate{
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 9;
  }

  ::v-deep{
    .el-input__inner{
      height: 30px;
      line-height: 30px;
    }
    .el-input-number .el-input__inner{
      padding: 0 30px;
    }
    .el-input-number{
      width: 90px;
      line-height: 30px;
      border-radius: 20px;
      overflow: hidden;
      .el-input__inner{
        background: rgba($color: #000000, $alpha: 0.4);
        border: 0;
        color: #fff;
      }
    }
    .el-input-number__decrease, .el-input-number__increase{
      width: 30px;
      height: 30px;
      top: 0;
      border: 0;
      background: transparent;
      color: #7d7d7d;
      font-weight: bold;
    }
    .el-input-number__decrease{
      left: 0;
    }
    .el-input-number__increase{
      right: 0;
    }
  }
</style>
